var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"not-found"},[_c('not-found')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }